<template>
    <div>
    
        <div v-for="image in currentPhotoBookImages" v-bind:key="image.id">
            <!-- photo-book-interior-spread v-if="image.id != currentSpread" :spreadId="image.id" :spreadType="'image_spread'" @click="selectCurrentSpored"></photo-book-interior-spread -->
            <photo-book-interior-spread :image="image.id" :spreadId="image.id" :spreadType="'image_spread'" @click="selectCurrentSpored"></photo-book-interior-spread>
        </div>

        <div v-for="spread in photo_book_spreads" v-bind:key="spread.id">
            <photo-book-interior-spread v-if="spread.id != currentSpread" :spreadId="spread.id"  :spreadType="'empty_spread'" @click="selectCurrentSpored"></photo-book-interior-spread>
            <photo-book-interior-spread v-if="spread.id == currentSpread" :image="image" :spreadId="spread.id" :spreadType="'empty_spread'" @click="selectCurrentSpored"></photo-book-interior-spread>
        </div>

    </div>
</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'

import PhotoBookInteriorSpread from './PhotoBookInteriorSpread.vue';

export default {
    name: "photo-book-interior-spread-list",
    components: {
        Modal,
        BaseAlert,
        PhotoBookInteriorSpread,
    },
    props: {
        image: '',
        imageReceived: '',
        loadedImage: '',
    },
    data() {
        return {
            loading: false,
            photo_book_images: [],
            photo_book_pages: [],
            photo_book_spreads: [],
            photo_book_pages_min_count: 60, // by spread = /2
            currentSpread: '',
            //image: '',
        };
    },
    methods: {
        receivedIamgeUploaded(){
            console.log("Load image in current spread ----- > "+this.currentSpread+" with image ----> "+this.loadedImage);
            this.image = this.loadedImage;
        },
        calculateMinimalSpreadCount() {
        },
        selectCurrentSpored(elem){
            console.log("spread selected ----> "+elem.id);
        },
        retrievePhotoBookImages() {
            
            let params = []
            params['pbid'] = this.$store.getters.currentPhotoBook.id;
            params['imagetype'] = 'interior';
            this.loading = true;
            this.$store.dispatch('fetchPhotoBookImages', params)
            .then(() => {
                console.log(this.$store.getters.currentPhotoBookImages);
               // console.log("theimages");
               this.photo_book_images = this.$store.getters.currentPhotoBookImages;
               this.createPhotoBookSpreads();
            })
            .catch((error) => {
                console.error(error);
                this.loading = true;
            }).finally(() => {
                    this.loading = false;

                    console.log("fetched data... creating spreads...");
                    
            });

        },
        retrievePhotoBookInteriorImages() {
            console.log("the one image");
            console.log(this.image);
            console.log("the one image");
            return this.$image_host+"/"+this.image.image.medium.url; 
            this.loading = true;
            let query = {};
            query["imgid"] = this.image.id;
            this.$api.getPhotoBookImage(this.image.imageable_id, this.image.id)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return 'http://0.0.0.0:8000/'+this.photo_book_image.image.medium.url; 
                });      
        },
        createPhotoBookSpreads() {
            this.photo_book_spreads = [];
            for (let i = this.photo_book_images.length; i < this.photo_book_pages_min_count; i++) {
                this.photo_book_spreads.push({
                    id: i,
                    image: null,
                });
                console.log("adding page #"+i);
            }
        },
    },
    watch: {
        imageReceived(newValue, oldValue) {
            console.log('queryParameter imageReceived changed from: ' + oldValue + ' -> ' + newValue);
            //nextStep();
            this.receivedIamgeUploaded();
        },
        loadedImage(newValue, oldValue) {
            console.log('queryParameter loadedImage changed from: ' + oldValue + ' -> ' + newValue);
            // nextStep();
            this.receivedIamgeUploaded();
        },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount', currentPhotoBookImages: 'currentPhotoBookImages' }),
    }, 
    mounted() {
        console.log(this.image);
        this.retrievePhotoBookImages();
        // this.createPhotoBookSpreads();
    },
};
</script>